import React, { useState } from 'react';
import { Checkbox } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import { NO_DATE } from '@/pages/opinion/constants';
import BubbleCommon from '../../../BubbleCommon';
import { useUpdateEffect } from 'ahooks';

export default function SingleCheckbox({
  onChange,
  key,
  defaultValue = true,
  defaultParams,
}: {
  onChange: (key: string, value: boolean) => void;
  key: string;
  defaultValue: boolean;
  defaultParams: any;
}) {
  const { text, tipsMap = null, value = false, showIcon = false, placement, className } = defaultParams;
  const { formatMessage } = useIntl();
  const [selected, setSelected] = useState(defaultValue);

  useUpdateEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div className={`single-checkbox-wrapper ${className}`}>
      <BubbleCommon tipsMap={tipsMap} showIcon={showIcon} placement={placement}>
        <Checkbox
          name="alertCountry"
          value={selected}
          onChange={(value) => {
            onChange?.(key, value);
            setSelected(value);
          }}
        >
          {formatMessage({ id: text || NO_DATE.EMPTY })}
        </Checkbox>
      </BubbleCommon>
    </div>
  );
}
